module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epi"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("I, [name], having been appointed an officer in the United Federation of Planets as indicated in the grade of captain, do solemnly swear to uphold the regulations of the United Federation Starfleet as well as the laws of the United Federation of Planets: to represent the highest ideals for which they stand, to become an ambassador of peace and goodwill, to protect the security of the Federation and its member worlds, and to offer aid to any and all beings that request it.")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "epi-att"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("—Starfleet Oath of Service")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0